import React from 'react'
import Footer from "../../components/layout/Footer/Footer";
import Header from "../../components/layout/Header/Header";
import CourseDetailsMain from '../../components/CourseDetails/CourseDetailsMain';
import { useLocation } from 'react-router';

const CourseDetailsPage = () => {
    const location = useLocation();
    const data = (location.state as any).selectedCourse
    return (
        <React.Fragment>
            <Header />
            <CourseDetailsMain course={data} />
            <Footer />
        </React.Fragment>
    )
}

export default CourseDetailsPage